/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Tolerance_Bands_InvalidInputs */

const en_error_tolerance_bands_invalid = /** @type {(inputs: Error_Tolerance_Bands_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some tolerance bands are not valid.`)
};

/**
* | output |
* | --- |
* | "Some tolerance bands are not valid." |
*
* @param {Error_Tolerance_Bands_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_tolerance_bands_invalid = /** @type {((inputs?: Error_Tolerance_Bands_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Tolerance_Bands_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_tolerance_bands_invalid(inputs)
});